BX.namespace('BX.Chili.Comments.ReviewsList');

/**
 * @param {Object} options
 * @param {Element} options.container
 *
 * @return  {BX.Chili.Comments.ReviewsList}
 * */
BX.Chili.Comments.ReviewsList = function (options){

    if(!new.target){
        return new BX.Chili.Comments.ReviewsList(options);
    }

    let self = this;

    this.options = options;

    this.container = this.options.container;
    this.list = this.options.container.querySelector('.chili-page-reviews-list');
    this.componentId = this.container.dataset.componentId;
    this.sortContainer = this.container.querySelector('.js-chili-sort');
    this.summarizeInfoContainer = this.container.querySelector('.chili-page-reviews-info');
    this.counterContent = this.container.querySelector('.red-comments-info > h1 > .red-gray'); // Счетчик отзывов

    this.sortMap = new Map(
        [
            ['date_asc', {value:'date_asc', arrow: '&#8595;'}],
            ['date_desc', {value:'date_desc', arrow: '&#8593;'}],
            ['rating_asc', {value:'rating_asc', arrow: '&#8595;'}],
            ['rating_desc', {value:'rating_desc', arrow: '&#8593;'}],
        ]
    );

    let currentSort = (this.sortContainer?.dataset.currentSort)?this.sortMap.get(this.sortContainer?.dataset.currentSort):this.sortMap.get('date_desc');

    this.sort = currentSort ?? this.sortMap.get('date_desc');

    function Pagination () {

        if(!new.target){
            return new Pagination();
        }

        /**@var {Element}*/
        this.listContainer = null;

        /**@var {Element}*/
        this.container = null;

        this.currentPage = 1;

        this.lastPage = 1;

        /**
         * Список загруженных страниц пагинации
         * @type {Object<number, Page>}
         */
        this.pages = {};

        /**
         * Описывает данные страницы пагинации
         *
         * @param {Object} options
         * @param {Element} options.pageElement Элемент, который содержит в себе контент страницы
         * @param {Number} options.pageNumber Номер страницы в пагинации
         * */
        function Page (options) {
            if (!new.target) {
                return new Page(options);
            }

            const visibleClassName = 'component-content--visible';

            let statesMap = new Map([['loading', "loading"], ['complete', "complete"]]);

            this.state = statesMap.get('loading');
            this.pageNumber = options.pageNumber;
            this.pageElement = options.pageElement;

            /**@param {'loading'|'complete'} state*/
            this.setState = (state) => {
                if (statesMap.has(state)) {
                    this.state = statesMap.get(state);
                }
            }

            this.setVisible = () => {
                if (this.pageElement && !this.pageElement?.classList?.contains(visibleClassName)) {
                    this.pageElement.classList.add(visibleClassName);
                }
            }

            this.setInVisible = () => {
                if (this.pageElement &&  this.pageElement?.classList?.contains(visibleClassName)) {
                    this.pageElement.classList.remove(visibleClassName);
                }
            }
        }

        this.updatePaginationContent = (paginationContent) => {
            if (this.container) {
                this.container.innerHTML = paginationContent.innerHTML;
            } else {
                this.container.append(paginationContent);
            }

            this.lastPage = this.normalizePage(this.container.dataset.lastPage)
        };

        this.registerPaginationHandlers = () => {

            // Установка обработчиков событий для элементов пагинации
            if (this.container) {
                this.container.addEventListener('click', (event) => {
                    ;(async (event) => {

                        // Обработка клика по номеру страницы
                        let button = event.target.closest('.red-page-number');

                        if (button) {
                            let page = button.querySelector('[data-page]')?.dataset.page;
                            await self.goToPage(page);
                            self.currentPage = page;
                        }

                        // Обработка клика "Показать еще"
                        let showMoreButton = event.target.closest('.chili-page-comments-show-more-btn');

                        if (showMoreButton) {
                            await self.showMorePage(showMoreButton.dataset.page);
                        }
                    })(event);
                });
            }
        };

        this.normalizePage = (page) => {
            page = parseInt(page);

            if(isNaN(page) || page < 1)
            {
                page = 1;
            }

            return page;
        };

        /**
         * Убирает видимость со всех страниц пагинации
         * @param {Number} except - исключает страницу с этим номером из обработки
         * */
        this.setInvisibleAllPages = (except) => {

            except = this.normalizePage(except);

            for(let key in this.pages){
                if(parseInt(key) !== except){
                    this.pages[key].setInVisible();
                }
            }
        }

        /**
         * Описывает данные страницы пагинации
         *
         * @param {Number} page Номер страницы в пагинации
         * @param {Element} element Элемент, который содержит в себе контент страницы
         * */
        this.addPage = (page, element) => {

            let paginationPage = new Page({
                pageElement: element,
                pageNumber: page
            });

            paginationPage.setState('complete');
            this.pages[page] = paginationPage;
        };

        /**
         * Открывает и показывает определенную страницу пагинации
         *
         * @param {Number} page
         * @param {boolean} preserveVisible не прятать видимые страницы
         * */
        this.showPage = (page, preserveVisible) => {
            page = this.normalizePage(page);

            if(!preserveVisible){
                self.pagination.setInvisibleAllPages(page);
            }

            self.pagination.pages[page]?.setVisible();
            self.pagination.currentPage = page;

            this.container.querySelectorAll('.red-page-number button').forEach((element)=>{
                element.disabled = false;
            });

            let currentButton = this.container.querySelector(`.red-page-number button[data-page="${page}"]`);

            if(currentButton){
                currentButton.disabled = true;
            }

            let showMoreButton =  this.container.querySelector('.chili-page-comments-show-more-btn');

            if(showMoreButton){
                if(page === this.lastPage){
                    showMoreButton.disabled = true;
                }
                else{
                    showMoreButton.disabled = false;
                    showMoreButton.dataset.page = page + 1;
                }
            }
        }

        this.clearPages = () => {
            for(const key in this.pages){
                this.pages[key].pageElement.remove();
            }

            this.pages = {};
            this.currentPage = 1;
            this.lastPage = 1;
        }

        let init = () => {
            this.listContainer = self.container;
            this.container = this.listContainer.querySelector('.chili-page-comments-pagination-container');
            this.lastPage = this.normalizePage(this.container.dataset.lastPage);
        }

        init();
    }

    this.pagination = new Pagination();

    this.loadPage =  async (page) =>
    {

        page = this.pagination.normalizePage(page);

        return BX.ajax
            .runComponentAction(
                "chililab:page.reviews.list",
                "getPage",
                {
                    mode: "class",
                    data: {
                        pageNum: page,
                        url: self.container.dataset.url,
                        componentId: self.container.dataset.componentId,
                        sort: self.sort.value
                    },
                }
            );
    }

    /**
     * Переход на определенную страницу.
     * Все остальные страницы скрываются
     *
     * @param {Number} page
     * */
    this.goToPage = async (page) => {
        page = this.pagination.normalizePage(page);

        // Что-то делаем только для нового номера страницы
        if(self.pagination.currentPage !== page){

            if(self.pagination.pages[page]){
                self.pagination.showPage(page);
            }
            else{
                // загружаем страницу перед показом
                try {
                    let response = await self.loadPage(page);

                    if(response.status  === 'success'){
                        const parser = new DOMParser();
                        let resultDocument = parser.parseFromString(response.data.html, 'text/html');
                        let newContent = resultDocument.querySelector('.component-content');

                        self.list.append(newContent);
                        self.pagination.addPage(page, newContent);
                        self.pagination.showPage(page);

                        let newPaginationContent = resultDocument.querySelector('.chili-page-comments-pagination-container');

                        if(newPaginationContent){
                            self.pagination.updatePaginationContent(newPaginationContent);
                        }

                    }
                    else{
                        throw new Error(response.errors)
                    }
                }
                catch (error){
                    console.error(error);
                }
            }

        }

    }

    /**
     * Показывает определенную страницу в добавление к остальным показанным страницам
     *
     * @param {Number} page
     * */
    this.showMorePage = async (page) => {
        page = self.pagination.normalizePage(page);

        if(self.pagination.pages[page]){
            // страница уже загружена
            self.pagination.showPage(page, true);
        }
        else {
            // загружаем страницу перед показом
            try {
                let response = await this.loadPage(page);

                if(response.status  === 'success'){
                    const parser = new DOMParser();
                    let resultDocument = parser.parseFromString(response.data.html, 'text/html');
                    let newContent = resultDocument.querySelector('.component-content');

                    self.pagination.addPage(page, newContent)
                    this.list.append(newContent);
                    self.pagination.showPage(page, true);

                    let newPaginationContent = resultDocument.querySelector('.chili-page-comments-pagination-container');

                    if(newPaginationContent){
                        self.pagination.updatePaginationContent(newPaginationContent);
                    }

                }
                else{
                    throw new Error(response.errors)
                }
            }
            catch (error){
                console.error(error);
            }
        }
    }

    /**
     * Перезагружает страницу. Удаляет из кеша все остальные страницы. Обновляет пагинацию.
     * Рекомендуется при добавлении/удалении комментариев, т.к. именно в этот момент пагинация меняется
     *
     * @param {Number} page
     * */
    this.reloadPage = async (page) => {

        page = self.pagination.normalizePage(page);

        try {
            let response = await this.loadPage(page);

            if(response.status  === 'success'){
                const parser = new DOMParser();
                let resultDocument = parser.parseFromString(response.data.html, 'text/html');
                let newContent = resultDocument.querySelector('.component-content') ?? '';

                let sortContent = resultDocument.querySelector('.js-chili-sort');
                let summarizeContent = resultDocument.querySelector('.chili-page-reviews-info'); // Статистика отзывов
                let counterContent = resultDocument.querySelector('.red-comments-info > h1 > .red-gray'); // Счетчик отзывов

                this.summarizeInfoContainer.innerHTML = summarizeContent.innerHTML;
                this.summarizeInfoContainer.removeAttribute('style');
                this.counterContent.innerHTML = counterContent.innerHTML;

                this.sortContainer.innerHTML = sortContent.innerHTML;
                this.sortContainer.dataset.currentSort = sortContent.dataset.currentSort;
                this.sort = this.sortMap.get(this.sortContainer.dataset.currentSort);

                this.pagination.clearPages();

                this.pagination.addPage(page, newContent);

                this.list.append(newContent);
                this.pagination.showPage(page);

                let newPaginationContent = resultDocument.querySelector('.chili-page-comments-pagination-container');

                if(newPaginationContent){
                    this.pagination.updatePaginationContent(newPaginationContent);
                }

            }
            else{
                throw new Error(response.errors)
            }
        }
        catch (error){
            console.error(error);
        }

    };

    this.changeSort = (newSort) => {
        (async ()=>{
            if(this.sortMap.has(newSort)){
                this.sort = this.sortMap.get(newSort);
                await this.reloadPage(1);
            }
        })()
    };

    this.like = (id) => {
        let reviewContainer = this.list.querySelector(`.chili-page-reviews-item[data-id="${id}"]`)

        BX.ajax
            .runComponentAction("chililab:page.reviews.list", "like", {
                mode: "class",
                data: { id: id },
            }).then(
            function (successResult) {
                const likesCount = reviewContainer.querySelector(
                    ".js-review-likes-count",
                );
                const dislikesCount = reviewContainer.querySelector(
                    ".js-review-dislikes-count",
                );
                if (likesCount )
                    likesCount.textContent = successResult.data.likes;
                if (dislikesCount)
                    dislikesCount.textContent =
                        successResult.data.dislikes;
            },
            function () {},
        );
    };

    this.disLike = (id) => {
        if(id){

            let reviewContainer = this.list.querySelector(`.chili-page-reviews-item[data-id="${id}"]`);

            BX.ajax
                .runComponentAction("chililab:page.reviews.list", "dislike", {
                    mode: "class",
                    data: { id: id },
                }).then(
                function (successResult) {
                    const likesCount = reviewContainer.querySelector(
                        ".js-review-likes-count",
                    );
                    const dislikesCount = reviewContainer.querySelector(
                        ".js-review-dislikes-count",
                    );
                    if (likesCount)
                        likesCount.textContent = successResult.data.likes;
                    if (dislikesCount)
                        dislikesCount.textContent =
                            successResult.data.dislikes;
                }
            );
        }
    };

    ;(()=>{
        this.list.querySelectorAll('.component-content').forEach((element)=>{
            let page =  element.dataset.page;
            this.pagination.addPage(page, element);
        });

        if (this.container.dataset.handlersRegistered === 'false') {

            this.sortContainer.addEventListener('click', (event)=>{
                let button = event.target.closest('.js-chili-reviews-sort');

                if(button){
                    this.changeSort(button.dataset.sort);
                }
            });

            this.pagination.registerPaginationHandlers();

            this.list.addEventListener('click', (event)=>{

                let like = event.target.closest('.js-chili-review-like');
                let dislike = event.target.closest('.js-chili-review-dislike');
                let review = event.target.closest('.chili-page-reviews-item');

                if(review && review.dataset.id){
                    if(like){
                        this.like(review.dataset.id)
                    }

                    if(dislike){
                        this.disLike(review.dataset.id)
                    }
                }
            });

            this.container.dataset.handlersRegistered = 'true';
        }


    })();

}
